import { nanoid } from 'nanoid';
import { browserStorageSetItem } from './browser-storage.util';

/**
 * Log-in user with google account
 * @param {string} baseUrl - endpoints base url
 * @param {string} redirectUrl - url to redirect to after successful login
 * @param {string} provider - provider to log-in with, default is 'google'
 */
const loginWithAuthProvider = (baseUrl, redirectUrl, provider = 'google') => {
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);
  const url = `${baseUrl}/v1/auth/idp/${provider}?redirect=${encodedRedirectUrl}`;
  localStorage.setItem('login', 'authProvider');
  window.location.href = url;
};

/**
 * Log-in user app with google account for the electron app
 * @param {string} redirectUrl - url to redirect to after successful login
 * @param {function} redirectToElectronFn - function that passes the url to electron (main) process via auth-redirect-channel to open the url in the default browser
 */
const electronLoginWithAuthProvider = (redirectUrl, redirectToElectronFn) => {
  // used to protect against csrf attacks, we pass the random value and check it when we get response back after successful login
  const authStateParam = nanoid(15);

  // we hit /logout endpoint which clears cognito cookies that prevent account select
  // due to pressence of redirect_uri we are redirected to /login endoint where we must select 'sing in with google'
  // becouse cookies were cleared we are presented with account select screen, after which we are redirected to redirect_uri
  // * we only get account select screen if we are logged in with multiple google accounts in a browser
  const base = `${process.env.VUE_APP_AUTH_HOST}/logout`;
  const queryParams = `response_type=code&client_id=${process.env.VUE_APP_AUTH_CLIENT_ID}&redirect_uri=${redirectUrl}&scope=openid+email+profile&state=${authStateParam}`;
  const url = `${base}?${queryParams}`;

  browserStorageSetItem('login', 'authProvider');
  browserStorageSetItem('authStateParam', authStateParam);

  redirectToElectronFn(url);
};

export { loginWithAuthProvider, electronLoginWithAuthProvider };
